// API base URL — proxied in dev via package.json "proxy"
const API_BASE = process.env.REACT_APP_API_URL || '/api';

const config = {
  apiBase: API_BASE,
};

export default config;
